import { combineReducers } from 'redux';
import nudge from './nudge';
import userInfo from './userInfo';
import ruleFilters from './ruleFilters';
import initializeData from './initializeData';
import createContent from './createContent';
import createSegment from './createSegment';
import campaign from './createSchedule';
import journeyDetails from './journeyDetails';
import notifications from './notifications';

const rootReducer = combineReducers({
  nudge,
  userInfo,
  ruleFilters,
  initializeData,
  createContent,
  createSegment,
  campaign,
  journeyDetails,
  notifications,
});

export default rootReducer;
